<template>
  <v-app>
    <template
      v-if="
        $auth.isAuthenticated &&
          this.$route.name &&
          !_.isEmpty(profile) &&
          !_.isEmpty(lookups)
      "
    >
      <v-row
        v-if="isSuperAdmin && runningAsEmail"
        :class="{
          primary: true,
          'run-as-bar': true,
          'run-as-bar--no-nav': hideDefaultNavigation
        }"
        dense
      >
        <v-col cols="12" class="text-center white--text">
          Running as {{ runningAsEmail }}
          <v-btn icon color="white" @click="clearRunAs">
            <v-icon>cancel</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        v-else-if="
          isAdmin &&
            pulses &&
            scheduled_pulse &&
            pulses.filter(x => x.sentDate != null && !x.isRegistration) == 0
        "
        :class="{
          accent: true,
          'run-as-bar': true,
          'run-as-bar--no-nav': hideDefaultNavigation
        }"
        dense
      >
        <v-col cols="12" class="text-center white--text my-auto">
          🚀 Fantastic! Your culture tracking survey has successfully been
          scheduled for
          {{ scheduled_pulse.scheduleDate | longDate }}!
        </v-col>
      </v-row>
      <template v-if="isSetup">
        <setup-app-bar></setup-app-bar>
      </template>
      <template v-else-if="hideDefaultNavigation"> </template>
      <template v-else>
        <app-bar></app-bar>
        <left-navigation></left-navigation>
        <insights-navigation-drawer
          v-if="isSuperAdmin"
        ></insights-navigation-drawer>
      </template>
      <v-main :class="isCheckin ? 'checkin-background' : ''">
        <router-view :key="$route.fullPath" />
      </v-main>
    </template>
    <loading-spinner v-else> </loading-spinner>
    <alert ref="alert"></alert>
    <confirm ref="confirm"></confirm>
    <v-snackbar
      ref="snackbar"
      v-model="snackbar"
      timeout="5000"
      :color="snackbarColor"
      top
      class="font-weight-bold"
    >
      <v-icon dark v-if="snackbarIcon">
        {{ snackbarIcon }}
      </v-icon>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn dark icon v-bind="attrs" @click="snackbar = false">
          <v-icon>close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import AppBar from "@/components/layout/AppBar";
import Alert from "@/components/layout/Alert";
import Confirm from "@/components/layout/Confirm";
import { getRunAs, setRunAs } from "@/helpers/local";
import { mapGetters } from "vuex";
import InsightsNavigationDrawer from "@/components/insights/InsightsNavigationDrawer";
import LeftNavigation from "@/components/layout/LeftNavigation";
export default {
  name: "App",

  components: {
    "app-bar": AppBar,
    alert: Alert,
    confirm: Confirm,
    InsightsNavigationDrawer,
    LeftNavigation
  },
  data: () => ({
    snackbar: false,
    snackbarColor: "success",
    snackbarText: "",
    snackbarIcon: "",
    runningAsEmail: ""
  }),
  watch: {
    is_admin(val, oldVal) {
      if (val != oldVal && val) {
        this.loadData();
      }
    }
  },
  computed: {
    isSetup: function() {
      return this.$route.meta.isSetup;
    },
    hideDefaultNavigation: function() {
      return this.$route.meta.hideDefaultNavigation;
    },
    isCheckin: function() {
      return this.$route.meta.isCheckin;
    },
    isSuperAdmin() {
      return this.$auth.isSuperAdmin();
    },
    isAdmin() {
      return this.$auth.isAdmin;
    },
    scheduled_pulse() {
      return this.pulses.find(x => x.sentDate == null);
    },
    ...mapGetters({
      pulses: "pulse/pulses",
      profile: "profile/profile",
      lookups: "lookup/all",
      settings: "profile/settings",
      is_admin: "profile/is_admin"
    })
  },
  methods: {
    openSnackbar(text, color, icon) {
      this.snackbarText = text;
      this.snackbarColor = color || "success";
      this.snackbar = true;
      this.snackbarIcon = icon;
    },
    openSnackbarSuccess(text) {
      this.openSnackbar(text, "success", "check-circle");
    },
    openSnackbarError(text) {
      this.openSnackbar(text, "error", "cancel");
    },
    clearRunAs() {
      this.runningAsEmail = "";
      setRunAs("");
    },
    loadData() {
      if (!this.is_admin) {
        return;
      }
      Promise.all([this.$store.dispatch("pulse/getOverview")])
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading your culture tracking surveys."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    this.runningAsEmail = getRunAs();
    this.loadData();
  },
  mounted() {
    this.$root.$alert = this.$refs.alert.open;
    this.$root.$confirm = this.$refs.confirm.open;
    this.$root.$snackbar = this.openSnackbar;
    this.$root.$snackbarSuccess = this.openSnackbarSuccess;
    this.$root.$snackbarError = this.openSnackbarError;
  }
};
</script>

<style lang="scss">
@import "src/scss/main.scss";
</style>

<style lang="scss" scoped>
::v-deep {
  .v-application--wrap {
    > .run-as-bar + .v-app-bar {
      top: 44px;
    }

    > .run-as-bar:not(.run-as-bar--no-nav) ~ .v-main {
      padding-top: 110px !important;
    }

    > .run-as-bar.run-as-bar--no-nav ~ .v-main {
      padding-top: 44px !important;
    }

    .run-as-bar {
      height: 44px;
      position: fixed;
      left: 0;
      right: 0;
      z-index: 5;
    }
  }
}
</style>
